<template>
  <nav class="navbar">
    <!-- Logo -->
    <router-link to="/">
      <img :src="Logo" alt="brand-logo" />
    </router-link>

    <!-- Links -->
    <DesktopMenu
      v-if="!showMenu"
      :blogRelatedPages="blogRelatedPages"
      :columnsRelatedPages="columnsRelatedPages"
      :tutorialRelatedPages="tutorialRelatedPages"
      @toForm="toForm"
    />
    <!-- <button
      v-if="!showMenu"
      class="primary-btn <tablet:hidden"
      @click.prevent="toForm"
    >
      聯絡我們
    </button> -->

    <!-- Mobile -->
    <MobileMenu v-if="showMenu" @close="showMenu = false" @toForm="toForm" />

    <img
      v-if="!showMenu"
      class="laptop:hidden w-[32px]"
      @click="openMenu"
      src="@/assets/icon/menu.svg"
      alt="menu-icon"
    />
    <img
      v-if="showMenu"
      @click="showMenu = false"
      src="@/assets/icon/close.svg"
      alt="menu-icon"
    />
  </nav>
</template>

<script setup>
import DesktopMenu from './components/DesktopMenu.vue'
import MobileMenu from './components/MobileMenu.vue'
import { computed, reactive, ref } from 'vue'
import { scrollPageTo } from '@/utils/helper'
import { useRoute, useRouter } from 'vue-router'
import Logo from '@/assets/beauty-logo.svg'
const route = useRoute()
const router = useRouter()
const page = computed(() => route.name)

const showMenu = ref(false)
const nestShow = reactive({
  solution: false,
})

const desktopNest = reactive({
  solution: false,
})

const blogRelatedPages = ['Blog', 'Article', 'ArticleTest', 'TagArticle']

const columnsRelatedPages = ['Columns', 'ColumnsArticle', 'ColumnsTagArticle']

const tutorialRelatedPages = ['Tutorial', 'TutorialList', 'TutorialContent']

const toForm = async () => {
  const blackList = [
    'Blog',
    'Article',
    'TagArticle',
    'Policy',
    'ArticleTest',
    'PrivacyPolicy',
    'ConsumerRights',
    'MemberTerms',
  ]
  if (!blackList.includes(page.value)) scrollPageTo('form')
  else {
    await router.push('/#form')
    setTimeout(() => {
      scrollPageTo('form')
    }, 300)
  }
}

const openMenu = () => {
  showMenu.value = !showMenu.value
}
</script>

<style lang="postcss" scoped>
.navbar {
  @apply relative w-full h-[72px] flex justify-between items-center bg-white px-[90px];
  @apply <laptop:(justify-between px-[16px]);
  line-height: 23px;
  box-shadow: 0px 1px 0px #dedede;
  border-bottom: #dedede solid 1px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
}

.nav-container {
  @apply grid grid-flow-col <laptop:hidden;
  @apply gap-4;
  @apply <desktop:(gap-2);
}

.mobile-nav-container {
  @apply absolute top-[72px] left-0 right-0 py-[12px];
  @apply bg-white text-left  text-secondary-dark;
  z-index: 5;
}

.router-link-container {
  @apply px-[28px] py-[9px];
}

.nest {
  @apply cursor-pointer;
  ul {
    @apply pt-[9px];
  }
}

.nest-container {
  @apply absolute top-[75px] z-5 bg-white rounded-sm text-left !pt-0;

  > li {
    @apply py-[9px] px-[12px] hover:bg-secondary-dark hover:text-white;
  }
}

.selected {
  @apply relative text-white;
}

.selected::before {
  content: '';
  @apply bg-secondary-dark w-full h-full absolute left-0 right-0 top-0 bottom-0;
  z-index: -1;
}

button {
  padding: 6px 20px;
  line-height: 23px;
}
</style>
